import React, {useState, useEffect} from 'react';
import {
  Switch,
  Route,
  useHistory,
  useLocation
} from "react-router-dom";
import NotilesQuestionPage from './NotilesQuestionPage'
import NotilesProductPage from './ProductSelectPage'
import WithtilesQuestionPage from './WithtilesQuestionPage'
import InspectionPage from './InspectionPage'
import CustomServicePage from './CustomServicePage'
import SummarizePage from './SummarizePage'
import ChooseTileTypePage from './ChooseTileTypePage'
import Promotion1Home from './Home'
// import WithtilesSummaryPage from './'

const options = {
  tilesSize: [
    {
      value: '25x40',
      label: '25 x 40 cm.'
    },
    {
      value: '30x30',
      label: '30 x 30 cm.'
    },
    {
      value: '30x60',
      label: '30 x 60 cm.'
    },
    {
      value: '40x40',
      label: '40 x 40 cm.'
    },
    {
      value: '40x60',
      label: '40 x 60 cm.'
    },
    {
      value: '45x45',
      label: '45 x 45 cm.'
    },
    {
      value: '50x50',
      label: '50 x 50 cm.'
    },
    {
      value: '60x60',
      label: '60 x 60 cm.'
    },
    {
      value: 'nodata',
      label: 'ไม่ทราบ'
    },
  ],
  areaType: [
    {
      value: 'floor',
      label: 'พื้น'
    },
    {
      value: 'ceiling',
      label: 'ผนัง'
    }
  ],
  room: [
    {
      value: 'restroom',
      label: 'ห้องน้ำ'
    },
    {
      value: 'bedroom',
      label: 'ห้องนอน'
    },
    {
      value: 'kitchen',
      label: 'ห้องครัว'
    },
    {
      value: 'livingroom',
      label: 'ห้องนั่งเล่น'
    },
    {
      value: 'multipurposeroom',
      label: 'ห้องเอกประสงค์'
    },
    {
      value: 'other',
      label: 'ห้องอื่นๆ'
    }
  ],
  floor: [
    {
      value: 'flr1',
      label: 'ชั้น 1'
    },
    {
      value: 'upperflr_lift',
      label: 'อยู่ชั้นบน และมีลิฟต์ขนของ'
    },
    {
      value: 'upperflr_nolift',
      label: 'อยู่ชั้นบน และไม่มีลิฟต์ขนของ'
    }
  ]
}
const tileslist = [
  {
      image: '/asset/products/tiles/01056151.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_01_result.png',
      name: 'PERLATO GLISTER',
      value: 'GH-F01',
      size: '60 x 60 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02072301"
  },
  {
      image: '/asset/products/tiles/01072235.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_02_result.png',
      name: 'AMAZON ST. GREY',
      value: 'GH-F02',
      size: '60 x 60 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02077101"
  },
  {
      image: '/asset/products/tiles/01059987.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_03_result.png',
      name: 'MARQUINA POL',
      value: 'GH-F03',
      size: '60 x 60 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02077901"
  },
  {
      image: '/asset/products/tiles/01072236.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_04_result.png',
      name: 'DREAMWOOD BEIGE LAPP',
      value: 'GH-F04',
      size: '60 x 60 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02076301"
  },
  {
      image: '/asset/products/tiles/01060104.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_05_result.png',
      name: 'IROKO PINE',
      value: 'GH-F05',
      size: '60 x 60 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02076301"
  },
  {
      image: '/asset/products/tiles/01072244.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_06_result.png',
      name: 'BENTO LAPPATO',
      value: 'GH-F06',
      size: '60 x 60 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02071001"
  },
  {
      image: '/asset/products/tiles/carsongrey.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_07_result.png',
      name: 'Carson Grey',
      value: 'DG-F01',
      size: '40 x 40 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02077101"
  },
  {
      image: '/asset/products/tiles/shuriken.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_08_result.png',
      name: 'Shuriken Grey',
      value: 'DG-F02',
      size: '50 x 50 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02071001"
  },
  {
      image: '/asset/products/tiles/santino.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_09_result.png',
      name: 'Santino Brown',
      value: 'DG-F03',
      size: '40 x 40 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02076301"
  },
  {
      image: '/asset/products/tiles/prado.jpg',
      topLayer: '/asset/products/PNG_F_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_F_S_1440_TILE_10_result.png',
      name: 'Prado Grey',
      value: 'DG-F04',
      size: '40 x 40 cm',
      unitprice: 123,
      type: "floor",
      yaneaw: "C02077101"
  },
  {
      image: '/asset/products/tiles/bolt.jpg',
      topLayer: '/asset/products/PNG_W_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_W_S_1440_TYPE02_WALL_01_result.png',
      name: 'Bolt Dark Grey (Satin)',
      value: 'DG-W01',
      size: '30 x 60 cm',
      unitprice: 123,
      type: "ceiling",
      yaneaw: "C02077401"
  },
  {
      image: '/asset/products/tiles/reina.jpg',
      topLayer: '/asset/products/PNG_W_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_W_S_1440_TYPE02_WALL_02_result.png',
      name: 'Reina Lightgrey (Satin)',
      value: 'DG-W02',
      size: '30 x 60 cm',
      unitprice: 123,
      type: "ceiling",
      yaneaw: "C02077101"
  },
  {
      image: '/asset/products/tiles/augusta.jpg',
      topLayer: '/asset/products/PNG_W_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_W_S_1440_TYPE02_WALL_03_result.png',
      name: 'Augusta Grey',
      value: 'DG-W03',
      size: '60 x 60 cm',
      unitprice: 123,
      type: "ceiling",
      yaneaw: "C02071001"
  },
  {
      image: '/asset/products/tiles/miso.jpg',
      topLayer: '/asset/products/PNG_W_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_W_S_1440_TYPE02_WALL_04_result.png',
      name: 'Miso White (Glossy)',
      value: 'DG-W04',
      size: '30 x 60 cm',
      unitprice: 123,
      type: "ceiling",
      yaneaw: "C02071001"
  },
  {
      image: '/asset/products/tiles/reinabeige.jpg',
      topLayer: '/asset/products/PNG_W_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_W_S_1440_TYPE02_WALL_05_result.png',
      name: 'Reina Beige',
      value: 'DG-W05',
      size: '30 x 60 cm',
      unitprice: 123,
      type: "ceiling",
      yaneaw: "C02071001"
  },
  {
      image: '/asset/products/tiles/grano.jpg',
      topLayer: '/asset/products/PNG_W_S_1440_OBJECT.png',
      layerImage: '/asset/products/tiles/PNG_W_S_1440_TYPE02_WALL_06_result.png',
      name: 'Grano White',
      value: 'DG-W06',
      size: '25 x 40 cm',
      unitprice: 123,
      type: "ceiling",
      yaneaw: "C02071001"
  }
]
const yaneawlist = [
  {
      image: '/asset/products/yaneaw/ขาวไข่มุก.jpg',
      layerImage: '/asset/products/yaneaw/ขาวไข่มุก.jpg',
      name: 'ขาวไข่มุก',
      value: 'C02071001',
      unitprice: 0
  },
  {
      image: '/asset/products/yaneaw/ครีม.jpg',
      layerImage: '/asset/products/yaneaw/ครีม.jpg',
      name: 'ครีม',
      value: 'C02072301',
      unitprice: 0
  },
  {
      image: '/asset/products/yaneaw/เทาประการัง.jpg',
      layerImage: '/asset/products/yaneaw/เทาประการัง.jpg',
      name: 'เทาปะการัง',
      value: 'C02077101',
      unitprice: 0
  },
  {
      image: '/asset/products/yaneaw/เทาธรรมชาติ.jpg',
      layerImage: '/asset/products/yaneaw/เทาธรรมชาติ.jpg',
      name: 'เทาธรรมชาติ',
      value: 'C02077201',
      unitprice: 65
  },
  {
      image: '/asset/products/yaneaw/เทาแกรนิต.jpg',
      layerImage: '/asset/products/yaneaw/เทาแกรนิต.jpg',
      name: 'เทาแกรนิต',
      value: 'C02077401',
      unitprice: 0
  },
  {
      image: '/asset/products/yaneaw/ดำลิกไนต์.jpg',
      layerImage: '/asset/products/yaneaw/ดำลิกไนต์.jpg',
      name: 'ดำลิกไนต์',
      value: 'C02077901',
      unitprice: 0
  },
  {
      image: '/asset/products/yaneaw/น้ำตาลทะเลทราย.jpg',
      layerImage: '/asset/products/yaneaw/น้ำตาลทะเลทราย.jpg',
      name: 'น้ำตาล ทะเลทราย',
      value: 'C02076701',
      unitprice: 0
  },
  {
      image: '/asset/products/yaneaw/น้ำตาลลาเต้.jpg',
      layerImage: '/asset/products/yaneaw/น้ำตาลลาเต้.jpg',
      name: 'น้ำตาลลาเต้',
      value: 'C02076301',
      unitprice: 0
  }
]

function Controller() {
  const history = useHistory();
  const location = useLocation();
  const [detailsSubmit, setDetailsSubmit] = useState(false)
  const [details, setDetails] = useState()
  const [serviceDetail, setServiceDetail] = useState([])
  const [selectedTile, setSelectedTile] = useState()
  const [selectedYaneaw, setSelectedYaneaw] = useState()

  // useEffect(()=>{
  //   if(detailsSubmit){
  //     if(details?.notile && location.pathname==="/tiles/notiles/question"){
  //       if(details?.areaSize===""||details?.sparePercent===""){
  //         history.push("/tiles/notiles/inspection");
  //       }
  //       else {
  //         history.push("/tiles/notiles/services");
  //       }
  //     }
  //     else if(details?.notile && location.pathname==="/tiles/withtiles/question"){
  //       if(details?.tilesSize===""||details?.areaSize===""||details?.sparePercent===""){
  //         history.push("/tiles/withtiles/inspection");
  //       }
  //       else {
  //         history.push("/tiles/withtiles/services");
  //       } 
  //     }
  //   }
  // },[detailsSubmit, {...details}])

  function handleSetDetails(val){
    setDetailsSubmit(true)
    setDetails(val)
    if(val?.notile && location.pathname==="/tiles/notiles/question"){
      if(val?.areaSize===""||val?.sparePercent===""){
        history.push("/tiles/notiles/inspection");
      }
      else {
        history.push("/tiles/notiles/services");
      }
    }
    else if(!val?.notile && location.pathname==="/tiles/withtiles/question"){
      if(val?.areaSize===""||val?.sparePercent===""){
        history.push("/tiles/withtiles/inspection");
      }
      else {
        history.push("/tiles/withtiles/services");
      } 
    }
  }

  function handleSetProduct(){
    history.push("/tiles/notiles/question");
  }

  function handleSummarySubmit(notile=false){
    console.log(notile)
    if(notile) history.push("/tiles/notiles/summary");
    else history.push("/tiles/withtiles/summary");
  }

  return (
    <>
      <Switch>
        <Route path="/tiles/withtiles/services">
          <CustomServicePage 
            details={details} 
            serviceDetail={serviceDetail}
            setServiceDetail={setServiceDetail} 
            handleSummarySubmit={()=>handleSummarySubmit(false)}
          />
        </Route>
        <Route path="/tiles/withtiles/summary">
          <SummarizePage 
            details={details} 
            serviceDetail={serviceDetail}
          />
        </Route>
        <Route path="/tiles/withtiles/inspection">
          <InspectionPage details={details} />
        </Route>
        <Route path="/tiles/withtiles/question">
          <WithtilesQuestionPage 
            options={options} 
            details={details} 
            setDetails={handleSetDetails} 
          />
        </Route>
        <Route path="/tiles/notiles/type">
          <ChooseTileTypePage />
        </Route>
        <Route path="/tiles/notiles/product/floor">
          <NotilesProductPage 
            type="floor"
            tileslist={tileslist} 
            yaneawlist={yaneawlist} 
            setTile={setSelectedTile}
            setYaneaw={setSelectedYaneaw}
            resetDetails={()=>setDetails(null)}
            handleSetProduct={handleSetProduct} 
          />
        </Route>
        <Route path="/tiles/notiles/product/wall">
          <NotilesProductPage 
            type="wall"
            tileslist={tileslist} 
            yaneawlist={yaneawlist} 
            setTile={setSelectedTile}
            setYaneaw={setSelectedYaneaw}
            resetDetails={()=>setDetails(null)}
            handleSetProduct={handleSetProduct} 
          />
        </Route>
        <Route path="/tiles/notiles/inspection">
          <InspectionPage 
          details={details} 
          selectedTile={selectedTile}
          selectedYaneaw={selectedYaneaw}
          />
        </Route>
        <Route path="/tiles/notiles/services">
          <CustomServicePage 
            details={details} 
            serviceDetail={serviceDetail}
            setServiceDetail={setServiceDetail} 
            handleSummarySubmit={()=>handleSummarySubmit(true)}
          />
        </Route>
        <Route path="/tiles/notiles/summary">
          <SummarizePage 
            details={details} 
            serviceDetail={serviceDetail}
            selectedTile={selectedTile}
            selectedYaneaw={selectedYaneaw}
            options={options}
          />
        </Route>
        <Route path="/tiles/notiles/question">
          <NotilesQuestionPage 
            options={options} 
            selectedTile={selectedTile} 
            selectedYaneaw={selectedYaneaw} 
            details={details} 
            setDetails={handleSetDetails} 
          />
        </Route>
        <Route>
            <Promotion1Home />
        </Route> 
      </Switch>
    </>
  );
}

export default Controller;
